import { injectable } from 'inversify';
import 'reflect-metadata';
import { Response } from '@/_shared/_api/models/response.model';
import axiosClient from './axios-client';
import { ERRORS } from '../constants/errors/error-messages.constants';
import { MarketInsightApiResponse } from '../_api/models/market-insights.model';

@injectable()
export class MarketInsightsService {
  async getMarketInsights(): Promise<Response<MarketInsightApiResponse>> {
    try {
      const response = await axiosClient.get<
        Response<MarketInsightApiResponse>
      >('/api/market-insights');
      return response.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async getPresignedUrl(
    title: string,
    fileName: string,
    marketInsightId: number
  ): Promise<string> {
    try {
      const response = await axiosClient.get(
        `/api/market-insights/${marketInsightId}/presigned-url?title=${title}&fileName=${fileName}`
      );
      return response.data.data;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
